import * as React from 'react';
import { Button } from '@gandi/ui';
import { getSupportEmail } from '../../lib/email';
import { Static } from '../Static';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NotFound({
  translator: {
    __
  },
  assetPath,
  locale,
  backLink,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Static, {
    title: __('404 - Page not found'),
    illustration: assetPath('img/NotFound.svg'),
    buttons: backLink && /*#__PURE__*/_jsx(Button, {
      href: backLink,
      children: __('Return to homepage')
    }),
    ...extraProps,
    children: [/*#__PURE__*/_jsx("p", {
      children: __('The requested page does not exist (or has been deleted).')
    }), /*#__PURE__*/_jsx("p", {
      children: __('If you typed a URL by hand, or used a bookmark, please double ' + 'check the address that you used.')
    }), /*#__PURE__*/_jsx("p", {
      dangerouslySetInnerHTML: __('If this page should have appeared and the error persists, please ' + '<a href="mailto:%(support_email)s">contact Customer Care</a> ' + 'and provide details about the action you tried to perform.', {
        withHTML: true,
        support_email: getSupportEmail(locale)
      })
    })]
  });
}
export default NotFound;